import React, { useCallback, useEffect, useMemo, useState } from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import { useMutation } from "@apollo/react-hooks";
import DataGrid from "components/data-grid";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { useQuery } from "components/graphql/query/use-query";
import { QueryResponseHandler } from "components/graphql";
import {
  defaultValues,
  mutation,
  handleSubmit,
  defaultValidationSchema,
  scoreboardValidationSchema,
  EditSourceForm,
  getSourceQuery,
} from "./forms/edit-form";
import ValidatedForm from "components/form";
import { getEntityWithoutTypename } from "pages/utils";

const SourceEditPage = ({
  intl,
  history,
  match: {
    params: { id },
  },
}) => {
  const [updateSource] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();
  const query = useMemo(() => getSourceQuery(id), [id]);
  const { data, loading } = useQuery(query);

  const [initialValues, setInitialValues] = useState(defaultValues);
  const sourceToEdit = data ? data.source : null;

  const [validationSchema, setValidationSchema] = useState();

  useEffect(
    () => {
      if (sourceToEdit) {
        const values = getEntityWithoutTypename(sourceToEdit);
        setInitialValues(values);
      }
    },
    [sourceToEdit],
  );

  const handleSelectValidationSchema = useCallback(
    sourceType =>
      setValidationSchema(
        sourceType === "scoreboard" ? scoreboardValidationSchema(intl) : defaultValidationSchema(intl),
      ),
    [intl],
  );

  return (
    <Dashboard>
      <QueryResponseHandler loading={loading} elements={sourceToEdit}>
        <PageHeaderBar title="app.page.source.edit" />
        <PageSection>
          <ValidatedForm
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit({ sourceId: id, updateSource, history, sourceToEdit, currentCustomerId })}
          >
            {props => (
              <DataGrid>
                <EditSourceForm onSelectValidationSchema={handleSelectValidationSchema} {...props} />
              </DataGrid>
            )}
          </ValidatedForm>
        </PageSection>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default SourceEditPage;
